import {
  Form,
  Input,
  InputNumber,
  DatePicker,
  Checkbox,
  Select,
  Space,
} from "antd";
import WrappingModal from "../../../../../components/Modals/WrappingModal";

interface Props {
  form: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  loading: boolean;
  currencies: any[];
  accounts: any[];
}

const FormModal = ({
  form,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  loading,
  currencies,
  accounts,
}: Props) => {
  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل خزنة" : "إضافة خزنة"}
    >
      <Form form={form} layout="vertical" onFinish={handleOk}>
        <Space direction="vertical" className="w-full" size="large">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {isEditing && (
              <Form.Item name="BoxID" label="رقم الخزنة">
                <InputNumber
                  placeholder="رقم الخزنة"
                  className="w-full"
                  disabled
                />
              </Form.Item>
            )}

            <Form.Item
              name="BoxName"
              label="اسم الخزنة"
              rules={[{ required: true, message: "برجاء إدخال اسم الخزنة" }]}
            >
              <Input placeholder="اسم الخزنة" />
            </Form.Item>

            <Form.Item
              name="CurrID"
              label="العملة"
              rules={[{ required: true, message: "برجاء اختيار العملة" }]}
            >
              <Select placeholder="اختر العملة">
                {currencies.map((curr) => (
                  <Select.Option key={curr.CurrID} value={curr.CurrID}>
                    {curr.CurrName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="CurrRate"
              label="سعر العملة"
              rules={[{ required: true, message: "برجاء إدخال سعر العملة" }]}
            >
              <InputNumber
                placeholder="سعر العملة"
                className="w-full"
                step={0.01}
              />
            </Form.Item>

            <Form.Item
              name="AccId"
              label="رقم الحساب"
              rules={[{ required: true, message: "برجاء اختيار رقم الحساب" }]}
            >
              <Select placeholder="اختر الحساب">
                {accounts.map((acc) => (
                  <Select.Option key={acc.AccID} value={acc.AccID}>
                    {acc.AccName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="FirstBalDate"
              label="تاريخ الرصيد الافتتاحي"
              rules={[{ required: true, message: "برجاء تحديد التاريخ" }]}
            >
              <DatePicker className="w-full" format="YYYY-MM-DD" />
            </Form.Item>

            <Form.Item
              name="FirstBal"
              label="الرصيد الافتتاحي"
              rules={[{ required: true, message: "برجاء إدخال الرصيد" }]}
            >
              <InputNumber
                placeholder="الرصيد الافتتاحي"
                className="w-full"
                step={0.01}
              />
            </Form.Item>

            <Form.Item name="IsCredit" valuePropName="checked">
              <Checkbox>دائن</Checkbox>
            </Form.Item>

            <Form.Item name="IsDebit" valuePropName="checked">
              <Checkbox>مدين</Checkbox>
            </Form.Item>
          </div>
        </Space>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
